import { FormattedMessage } from 'react-intl';

import { FootballRivalsCompetitionSortType } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal, SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';

import { SectionTitle } from 'components/rivals/RivalsMatchesDateLayout/FavoriteCompetitionsTitle';
import { SortBy, sortings } from 'components/rivals/SortBy';

type Props = {
  sortBy?: FootballRivalsCompetitionSortType;
  onSortChange?: (sorting: FootballRivalsCompetitionSortType) => void;
};
export const OrderedSectionTitle = ({ sortBy, onSortChange }: Props) => {
  return (
    <SectionTitle>
      <SBHorizontal>
        <LabelS bold as="h3">
          <Horizontal gap={0.5}>
            <span>
              <FormattedMessage
                id="RivalsMatchesDateLayout.section.orderedCompetitions"
                defaultMessage="Competitions"
              />
            </span>
            {sortBy && (
              <span>
                (<FormattedMessage {...sortings[sortBy].shortLabel} />)
              </span>
            )}
          </Horizontal>
        </LabelS>
        {sortBy && onSortChange && (
          <SortBy sortBy={sortBy} onSortChange={onSortChange} />
        )}
      </SBHorizontal>
    </SectionTitle>
  );
};
